import { render } from "./BoardView.vue?vue&type=template&id=c10a8a14&ts=true"
import script from "./BoardView.vue?vue&type=script&lang=ts"
export * from "./BoardView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__